import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';
import { isLoggedIn } from '../../globalFunctions/apiFunctions';


function NavBar (props) {
	isLoggedIn().then( res =>{
		if(!res.data.loggedIn) return;
		const { transactions, stocks, user, account_balance } = res.data

		props.userState.dispatch({
		  type: 'LOGIN',
          user_id: user,
          account_balance: account_balance,
          transactions: transactions,
          stocks: stocks
		})
	})

	return (
		<div className="navigation-bar">
			{ props.userState.userState.loggedIn && (
				<Fragment>
					<Link to="/portfolio">Portfolio</Link>|
					<Link to="/transactions">Transactions</Link>
				</Fragment>
			)}
		</div>
	);
}

export default NavBar;
